// removed by extract-text-webpack-plugin
module.exports = {"button":"_1nv62rxsskTHy-kOUZhvVg","buttonDefaultStyle":"_3iO8KFw1CZ2X4-bxy-o6bZ","selected":"_2igBDWEz_4AkfG-zAaYNwA","textContainer":"BWmqsBiWsCxWO_D0S2oqb","betChipsContainer":"dcTL6JLd2F45McDofCG_m","betChips":"ZbG1zYgTxbZkpNondwOxr","chipValueOuter":"_3cpdLw2CtpmuctaFSBKCaV","chipValueInner":"_184FwJQ6piNxloVdQmLIrp"};


//////////////////
// WEBPACK FOOTER
// ./src/ui-modules/simplified/mobile/modules/football/css/button.css
// module id = 1014
// module chunks = 0